"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  roleCertificationApplication: {
    cargoOwner: '货主',
    forwarder: '货代',
    transportTeam: '车队',
    viewLink: '查看链接',
    roleApplication: '角色申请认证',
    uploadAttachment: '上传文件',
    notBeEmpty: '不能为空',
    companyType: '公司类型',
    companyName: '公司LOCAL全称',
    companyNameEn: '公司英文全称',
    usci: '统一社会信用码',
    companyAbbrev: '公司简称',
    companyAddress: '公司地址',
    country: '国家（地区）',
    province: '省（市）',
    city: '城市',
    businessLicenseScanningCopy: '营业执照副本',
    importEdoPromise: '进口预约换单承诺书',
    simisCompanyCode: '公司代码',
    simisCompanyNameCn: '公司中文名称',
    simisCompanyNameEn: '公司英文名称',
    jpBookingForwarderCode: '代理',
    faxNo: '传真',
    freightDeliveryMethod: '运费发送方式',
    emailCheck: 'Email',
    faxCheck: 'Fax',
    portCode: '选择港口',
    MobilePhone: '手机',
    contactMobilePhone: '电话',
    contactPhone: '固定电话',
    taxNo: '税号',
    edoUnitType: '申报单位类型',
    edoUserName: '申报员名称',
    edoUserIdNumber: '申报员身份证号',
    edoEmail: '邮箱',
    bookingJp: '日本起运港订舱',
    bookingNotJp: '非日本起运港订舱',
    outDgDec: '出口危险品申报',
    inEdo: '进口预约换单',
    terms: '用户条款和须知',
    agreement: '已阅读并同意',
    confirm: '同意以上条款并确认',
    edit: '编辑',
    notReject: '只有拒绝状态才能编辑!',
    notEdit: '当前账号是子账号无需申请!',
    deleteMessage: '删除成功',
    businessLicenseScanningCopyNotNull: '营业执照副本不能为空',
    invalidPhone: '电话格式错误',
    roleDetail: '角色认证申请明细',
    roleCode: "角色",
    port: "港口",
    authStatus: "认证状态",
    applyDate: "申请日期",
    approveRemark: "审批批注",
    agent: "代理",
    phone: "电话",
    fax: "传真",
    freightSendingMethod: "运费发送方式",
    applying: "申请中",
    approving: "审批中",
    approved: "审批通过",
    rejected: "拒绝",
    saveSuccessfully: '保存成功',
    agreeTerms: '请阅读并同意条款',
    add: '申请权限',
    compangEnMessage: '只能填字母和英文的符号',
    tips: '注: 如果需要修改公司信息及营业执照副本，请先作废所有审批完成的角色，然后编辑权限申请。',
    cancel: '作废',
    cancelSuccess: '作废成功',
    errMsg: '请求数据失败，请稍后再试',
    confirmContent: '是否作废？',
    customerType: '客户类型'
  },
  roleCertificationApplicationTable: {
    roleCode: '角色',
    officeAbbrev: '机构简称',
    portCode: '港口',
    jpBookingForwarderCode: '代理',
    authStatus: '认证状态',
    applyDate: '申请日期',
    actions: '操作'
  }
};